export default __webpack_public_path__ + "static/media/cleary.9e407fed.jpg";